import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';
import { Region } from 'src/app/models/region.model';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  private pathApi = this.config.setting['pathApi'] + "region/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  get(id: any): Observable<any> {
    return this.http.get(`${this.pathApi}${id}`);
  }
  
  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  }
  
  getAllUsersRegions(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllUsersRegions`);
  }

  save(obj: Region): Observable<any> {
    return this.http.post(`${this.pathApi}save`, obj);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  } 

  uploadFile(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadFile`, obj);
  }

  getTemplate(): Observable<any>{
    return this.http.get(`${this.pathApi}getTemplate`);
  }

  getRegionsForOptions(): Observable<any> {
    return this.http.get(`${this.pathApi}getRegionsForOptions`);
  }

  getRegionsForOptionsByUser(): Observable<any> {
    return this.http.get(`${this.pathApi}getRegionsForOptionsByUser`);
  }
}
